var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('a-row',{attrs:{"type":"flex"}},[_c('a-col',{attrs:{"span":24}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }